<template>
    <span title="This is how long since it was last updated">{{ relativeTime }}</span>
</template>

<script>
    export default {
        name: 'relative-time-formatter',
        props: { time: {required:true} },
        data() {
            return {
            }
        },
        computed: {
            relativeTime: {
                get: function() {
                    let str = moment( this.time ).fromNow()
                    str = str.replace(/a few seconds ago/, "just now")
                        .replace(/minute/, "min")
                        .replace(/hour/, "hr")
                    return str;
                }
            }
        }
    }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/RelativeTimeFormatter.vue